import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

import { computed, Ref, ref, VNodeRef } from 'vue';
import _ from 'lodash';
import { isEmpty } from 'src/common/arrayUtil';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';

type IoDropdownOption = {[key: string]: unknown} & {disabledTooltipText?: string,  disabled?: boolean} | unknown;


export default /*#__PURE__*/_defineComponent({
  __name: 'DropDown',
  props: /*#__PURE__*/_mergeModels({
    options: {},
    optionLabel: { default: '' },
    optionValue: { default: '' },
    label: { default: '' },
    iodineClassName: { default: '' },
    popupContentClass: { default: '' },
    multiple: { type: Boolean },
    checkBoxes: { type: Boolean },
    readState: { type: Boolean, default: false },
    disabledOptionTooltip: { default: '' },
    disableAllOptions: { type: Boolean, default: false },
    ioClearable: { type: Boolean, default: false }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const selectRef = ref<VNodeRef | null>(null);
const model = _useModel<IoDropdownOption[] | IoDropdownOption | undefined, string>(__props, "modelValue");
const {readOnly} = storeToRefs(useGrouperStore());

const props = __props;

const hasValue = computed(() => {
  return (
    model &&
    (Array.isArray(model.value) ? !isEmpty(model.value) : model.value != null)
  );
});

function clearValue() {
  if (props.multiple) {
    model.value = [];
  } else {
    model.value = undefined;
  }
}

function optionClick(opt: IoDropdownOption) {
  if (props.multiple) {
    // model must be an array
    let index;
    if(props.optionValue && props.optionValue !== '') {
      index = (model.value as IoDropdownOption[]).findIndex(item => _.get(item, 'value') === _.get(opt, props.optionValue));
    } else {
      index = (model.value as IoDropdownOption[]).indexOf(opt);
    }

    if (index == -1) {
      (model.value as IoDropdownOption[]).push(opt);
    } else {
      (model.value as IoDropdownOption[]).splice(index, 1);
    }
  } else {
    model.value = opt;
    selectRef.value?.hidePopup();
  }
}

function disabledTooltipText(opt: IoDropdownOption) {
  return _.get(opt, 'disabledTooltipText') || props.disabledOptionTooltip;
}

function optionDisabled(opt: IoDropdownOption) {
  return _.get(opt, 'disabled') || props.disableAllOptions;
}

function isTooltipDisabled() {
  return readOnly.value;
}

const spanRefMap: Map<string, Ref> = new Map<string, Ref>();

function getOptionSpanRef(opt: IoDropdownOption): Ref {

  const key = <string>(props.optionValue ? _.get(opt, props.optionValue) : opt);

  if (spanRefMap.has(key)) {
    return <Ref>spanRefMap.get(key);
  }

  const spanRef = ref(null);
  spanRefMap.set(key, spanRef);
  return spanRef;
}

function optionDisplay(opt: IoDropdownOption) {
  return props?.optionLabel ? _.get(opt, props?.optionLabel) : opt;
}

function optionOverflowed(opt: IoDropdownOption) {
  var element = getOptionSpanRef(opt);

  return element?.value && element?.value.offsetWidth < element?.value.scrollWidth;
}

function classNames() {
  return props.iodineClassName + (isTooltipDisabled() && !props.readState ? ' io-mfe-ig-drop-down-disabled': '');
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    ref_key: "selectRef",
    ref: selectRef,
    outlined: "",
    dense: "",
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
  }, props, {
    class: ["io-mfe-ig-drop-down", classNames()],
    "dropdown-icon": "fa-duotone fa-solid fa-circle-caret-down",
    for: `dropdown-${_ctx.iodineClassName}`,
    "popup-content-class": 
      'io-mfe-ig-drop-down-portal' +
      (_ctx.popupContentClass ? ' ' + _ctx.popupContentClass : '')
    
  }), {
    append: _withCtx(() => [
      (hasValue.value && _ctx.ioClearable && !isTooltipDisabled())
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "fa-regular fa-circle-x",
            onClick: _withModifiers(clearValue, ["stop","prevent"]),
            class: "cursor-pointer"
          }))
        : _createCommentVNode("", true)
    ]),
    option: _withCtx(({ opt, selected }) => [
      (!isTooltipDisabled())
        ? (_openBlock(), _createBlock(_component_q_item, {
            key: 0,
            clickable: "",
            disable: optionDisabled(opt),
            onClick: ($event: any) => (!optionDisabled(opt) && optionClick(opt)),
            class: _normalizeClass({ 'io-mfe-ig-drop-down-selected': selected })
          }, {
            default: _withCtx(() => [
              (optionDisabled(opt) && disabledTooltipText(opt))
                ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(disabledTooltipText(opt)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (_ctx.checkBoxes)
                ? (_openBlock(), _createBlock(_component_q_item_section, {
                    key: 1,
                    side: "",
                    top: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_checkbox, {
                        "model-value": selected,
                        "onUpdate:modelValue": ($event: any) => (optionClick(opt)),
                        disable: optionDisabled(opt)
                      }, null, 8, ["model-value", "onUpdate:modelValue", "disable"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      (optionOverflowed(opt))
                        ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(optionDisplay(opt)), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        ref: getOptionSpanRef(opt)
                      }, _toDisplayString(optionDisplay(opt)), 513)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["disable", "onClick", "class"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["modelValue", "class", "for", "popup-content-class"]))
}
}

})